import { HomeHeroSlide } from '@/screens/Home'

export const getSaleView = (slide: HomeHeroSlide, index: string) => {
	return {
		ecommerce: {
			promoView: {
				promotions: [
					{
						id: slide.ID,
						name: `Баннер "${slide.NAME}"`,
						position: index
					}
				]
			}
		}
	}
}
